const acordeon = (selector: string | HTMLElement, unico: boolean = true) => {
    const contenedor = typeof selector === 'string' ? document.querySelector<HTMLDivElement>(selector) : selector;

    if (!contenedor) {
        return;
    }

    let botones: HTMLButtonElement[] = [].slice.call(contenedor.querySelectorAll<HTMLButtonElement>('[aria-controls]')),
        paneles: HTMLElement[] = botones.map(boton => contenedor.querySelector('#' + boton.getAttribute('aria-controls')!)!),
        moviendo = false;

    const pliega = (posicion: number) => {
        const panel = paneles[posicion],
            boton = botones[posicion];

        panel.style.height = panel.scrollHeight + 'px';
        moviendo = true;
        setTimeout(() => {
            panel.addEventListener('transitionend', () => {
                panel.hidden = true;
                moviendo = false;
                boton.setAttribute('aria-expanded', 'false');
            }, {once: true});
            panel.style.height = '0';
        }, 16);
    }

    const despliega = (posicion: number) => {
        const panel = paneles[posicion],
            boton = botones[posicion];

        moviendo = true;
        panel.hidden = false;
        panel.addEventListener('transitionend', () => {
            panel.style.height = 'auto';
            moviendo = false;
            boton.setAttribute('aria-expanded', 'true');
        }, {once: true});
        panel.style.height = panel.scrollHeight + 'px';
    }

    const cambiaPanel = (posicion: number) => {
        if (moviendo || posicion < 0) {
            return;
        }

        if (unico) {
            for (let i = 0; i < botones.length; i += 1) {
                if (i !== posicion) {
                    pliega(i);
                }
            }

            despliega(posicion);
            return;
        }

        if (paneles[posicion].hidden) {
            despliega(posicion);
        } else {
            pliega(posicion);
        }
    }

    contenedor.addEventListener('click', e => {
        const boton = e.target as HTMLButtonElement;

        if (!boton || boton.nodeName !== 'BUTTON') {
            return;
        }

        cambiaPanel(botones.indexOf(boton));
    });

    contenedor.addEventListener('keydown', e => {
        const boton = e.target as HTMLButtonElement;

        if (!boton || boton.nodeName !== 'BUTTON') {
            return;
        }

        switch (e.key) {
            case 'Enter':
                cambiaPanel(botones.indexOf(boton));
                e.preventDefault();
                break;
            case 'Space': {
                cambiaPanel(botones.indexOf(boton));
                break;
            }
            case 'ArrowDown': {
                const siguiente = (botones.indexOf(boton) + 1) % botones.length;
                botones[siguiente].focus();
                e.preventDefault();
                break;
            }
            case 'ArrowUp': {
                const posicion = botones.indexOf(boton),
                    siguiente = posicion === 0 ? botones.length - 1 : posicion - 1;
                botones[siguiente].focus();
                e.preventDefault();
                break;
            }
            case 'Home': {
                botones[0].focus();
                e.preventDefault();
                break;
            }
            case 'End': {
                botones[botones.length - 1].focus();
                e.preventDefault();
                break;
            }
        }
    }, true);

    return {
        actualiza: () => {
            botones = [].slice.call(contenedor.querySelectorAll<HTMLButtonElement>('[aria-controls]'));
            paneles = botones.map(boton => document.getElementById(boton.getAttribute('aria-controls')!)!);
        }
    }
}

export default acordeon;